import { render } from "./nowcast_info_page.vue?vue&type=template&id=130201b1"
import script from "./nowcast_info_page.vue?vue&type=script&lang=js"
export * from "./nowcast_info_page.vue?vue&type=script&lang=js"

import "./nowcast_info_page.vue?vue&type=style&index=0&id=130201b1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__